import type { FrontendWidget } from '../types';
import { BundeslandLocationsListComponent } from './BundeslandLocationsListComponent';
import { BundeslandLocationsListComponentB } from './BundeslandLocationsListComponentB';
import { BundeslandLocationsListComponentC } from './BundeslandLocationsListComponentC';
import type {
  BundeslandLocationsListConfig,
  BundeslandLocationsListResolved,
} from './types';

export const bundeslandLocationsListWidget: FrontendWidget<
  BundeslandLocationsListConfig,
  BundeslandLocationsListResolved
> = {
  componentType: 'widgets.bundesland-locations-list',
  displayName: 'Bundesland Locations List',
  ComponentA: BundeslandLocationsListComponent,
  ComponentB: BundeslandLocationsListComponentB,
  ComponentC: BundeslandLocationsListComponentC,
  // No resolveSync — lookup widget. Resolved data arrives from the backend.
};
